import AxiosInstance from '../axios/AxiosInstance';
import { viewQuotationPDF, downloadQuotationPDF } from '../utils/pdfGenerator';

export const devisService = {
  // Récupérer tous les devis du client connecté avec pagination
  async getClientDevis(page = 1, limit = 20) {
    try {
      const response = await AxiosInstance.get(`/quotation/client?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des devis:', error);
      throw error;
    }
  },

  // Récupérer un devis spécifique pour génération PDF
  async getDevis(devisId) {
    try {
      const response = await AxiosInstance.get(`/quotation/${devisId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du devis:', error);
      throw error;
    }
  },

  // Télécharger un devis (génération côté client)
  async downloadDevis(devis) {
    try {
      downloadQuotationPDF(devis);
      return true;
    } catch (error) {
      console.error('Erreur lors du téléchargement du devis:', error);
      throw error;
    }
  },

  // Voir un devis (génération côté client)
  async viewDevis(devis) {
      viewQuotationPDF(devis);
  },

  // Générer un code de signature pour les devis
  async generateSignatureCode(quotationIds) {
    try {
      const response = await AxiosInstance.post('/quotation/generate-code', {
        quotationIds
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la génération du code:', error);
      throw error;
    }
  },

  // Signer des devis
  async signQuotations(quotationsIds, validateCode) {
    try {
      const response = await AxiosInstance.post('/quotation/sign', {
        quotationsIds,
        validateCode
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la signature des devis:', error);
      throw error;
    }
  },

  // Refuser un devis
  async rejectQuotation(quotationId, reason) {
    try {
      const response = await AxiosInstance.post('/quotation/reject', {
        quotationId,
        reason
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors du refus du devis:', error);
      throw error;
    }
  },

  // Valider un devis (pour les endpoints futurs)
  async validateDevis(devisId) {
    try {
      const response = await AxiosInstance.post(`/quotation/validate/${devisId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la validation du devis:', error);
      throw error;
    }
  },

  // Rejeter un devis (pour les endpoints futurs)
  async rejectDevis(devisId, reason) {
    try {
      const response = await AxiosInstance.post(`/quotation/reject/${devisId}`, {
        reason: reason
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors du rejet du devis:', error);
      throw error;
    }
  }
};
